
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 14.25v9m0-1.5h16.5a3 3 0 0 0-3-3H10.5a3 3 0 0 0-3-3H.75m6 3h3.75m9.74-.742a7.475 7.475 0 0 0-2.022-13.059l1.853-3.17a.679.679 0 0 0 0-.687.707.707 0 0 0-.611-.342h-7.42a.707.707 0 0 0-.609.342.679.679 0 0 0 0 .687l1.853 3.17A7.477 7.477 0 0 0 8.25 12","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M13.7 13.844a2.224 2.224 0 0 0 1.858.875c1.139 0 2.063-.693 2.063-1.547s-.924-1.546-2.063-1.546-2.058-.693-2.058-1.548.924-1.547 2.062-1.547a2.221 2.221 0 0 1 1.858.875m-1.858 5.313v1.031m0-8.25v1.031","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    